import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ==== APP VERSION CHECK - MUST RUN BEFORE ANYTHING ====
const APP_VERSION = "2.0.0";
const storedVersion = localStorage.getItem("servicego_app_version");

// Version mismatch - clear storage but DON'T redirect
// Let the app naturally show Welcome page for new users
if (storedVersion !== APP_VERSION) {
  // Clear ALL storage to reset any stale state
  localStorage.clear();
  sessionStorage.clear();
  
  // Save new version AFTER clear
  localStorage.setItem("servicego_app_version", APP_VERSION);
  
  // Don't redirect - let the app render normally
  // New users will see Welcome, returning users will re-login if needed
}

// ==== PWA CLEANUP - UNREGISTER ALL SERVICE WORKERS ====
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
      console.log('ServiceGo: Service worker unregistered');
    });
  });
}

// ==== CLEAR ALL PWA CACHES ====
if ('caches' in window) {
  caches.keys().then(cacheNames => {
    cacheNames.forEach(cacheName => {
      caches.delete(cacheName);
      console.log('ServiceGo: Cache deleted:', cacheName);
    });
  });
}

// ==== RENDER APP ====
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
